<h2 mat-dialog-title>{{title}}</h2>
@if (busy) {
  <div class="overlay">
    <div class="center">
      <mat-spinner>
      </mat-spinner>
    </div>
  </div>
}
<mat-dialog-content>
  @if (!resultReceived) {
    <div class="w-100 flex-col justify-center items-center mt-3">
      <span>I want to bid</span>
      <span class="amount">{{bidAmount | currency : 'USD' : 'symbol' : '1.2'}}</span>
      <span>on this property</span>
    </div>
  }
  @else {
    <div class="w-100 flex-col justify-center items-center mt-3">
      <span>{{resultText}}</span>
      <span>{{resultDetails}}</span>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions >
  <div class="w-100 flex-row space-between items-center mt-3 p-2">
    @if (!resultReceived) {
      <button [disabled]="!canSubmit" mat-flat-button class="w-50" color="primary" (click)="onConfirmClick()" tabindex="1" >{{confirmButtonText}}</button>
    }
    <button [disabled]="!canCancel" [ngClass]="resultReceived?'w-100':'w-50'" mat-flat-button color="primary" (click)="onCancelClick()" >{{cancelButtonText}}</button>
  </div>
</mat-dialog-actions>

